const getDefaultState = () => {
    return {
        list: [],
        list_loading: false,
        available_tokens: [],
        form: { name: '', content: '' },
        form_loading: false,
        detail: null,
        detail_loading: false
    }
}
import { updateField, getField } from "vuex-map-fields";
import { SET_LIST, RESET_STATE } from "../constant-types";
import {defaultAddInListMutation, defaultSetListMutation, defaultUpdateInListMutation} from "../default-method";
import {
requestCreate,
    requestUpdate,
    sendRequest
} from "./../api";

export default({
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        [RESET_STATE](state) {
            // Merge rather than replace so we don't lose observers
            // https://github.com/vuejs/vuex/issues/1118
            Object.assign(state, getDefaultState())
        },
        ...defaultSetListMutation,
        ...defaultAddInListMutation,
        ...defaultUpdateInListMutation,
        SET_FORM(state, payload) {
            state.form = JSON.parse(JSON.stringify(payload))
        },
        RESET_FORM(state) {
            state.form.name = ''
            state.form.content = ''
        },
        SET_LIST_LOADING(state, payload) {
            state.list_loading = payload
        },
        SET_DETAIL(state, payload) {
            state.detail = payload
        },
        SET_DETAIL_LOADING(state, payload) {
            state.detail_loading = payload
        },
        updateField
    },
    actions: {
        loadList({commit}) {
            commit('SET_LIST_LOADING', true)
            return sendRequest('billing-customer-template', {}, 'get', (response) => {
                commit(SET_LIST, response)
                commit('SET_LIST_LOADING', false)
            }, ()=>{}, ()=>{})
        },
        loadAvailableToken({commit}) {
            return sendRequest('billing-customer-template/available-token', {}, 'get', (response) => {
                commit('updateField', { path: 'available_tokens', value: response })
            }, ()=>{}, ()=>{})
        },
        requestCreateTemplate({commit, state}) {
            return requestCreate('billing-customer-template', state.form, commit)
        },
        requestUpdateTemplate({commit, state}) {
            return requestUpdate(`billing-customer-template/${state.form.id}`, state.form, commit)
        },
        loadDetail({commit}, billingCustomerTemplateId) {
            commit('SET_DETAIL_LOADING', true)
            return sendRequest('billing-customer-template/' + billingCustomerTemplateId, {}, 'get', (fetchedDetail) => {
                commit('SET_DETAIL', fetchedDetail)
                commit('SET_DETAIL_LOADING', false)
            })
        }
    },
    getters: {
        getField
    }
})
